import clsx from 'clsx';

// images
import emojiImg from '@assets/emoji.png';

// styles
import css from './styles.module.css';

interface IProps {
  text: string;
  active?: boolean;
}

function Notificaiton({ text, active }: IProps) {
  return (
    <div className={clsx(css.notification, { [css.active]: active })}>
      <img src={emojiImg} alt="emoji icon" className={css.notificationImage} />
      {text}
    </div>
  );
}

export default Notificaiton;
